import {Injectable} from '@angular/core';
import {AppHttpClient} from '@common/core/http/app-http-client.service';
import {BuilderProject, FtpDetails} from '../builder-types';
import {Project} from './Project';
import {PaginatedBackendResponse} from '@common/core/types/pagination/paginated-backend-response';
import {BackendResponse} from '@common/core/types/backend-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Projects {
    static BASE_URI = 'projects';
    constructor(private http: AppHttpClient, private httpClient: HttpClient) {}

    all(params?: {user_id?: number, per_page?: number}): PaginatedBackendResponse<Project> {
        return this.http.get(Projects.BASE_URI, params);
    }

    get(id: number): BackendResponse<{project: BuilderProject}> {
        return this.http.get(`${Projects.BASE_URI}/${id}`);
    }
    unpublish(id: number): BackendResponse<{project: BuilderProject}> {
        return this.http.get(`${Projects.BASE_URI}/${id}/unpublish`);
    }

    create(params: object): BackendResponse<{project: BuilderProject}> {
        return this.http.post(Projects.BASE_URI, params);
    }

    update(id: number, params: object): BackendResponse<{project: BuilderProject}> {
        return this.http.put(`${Projects.BASE_URI}/${id}`, params);
    }

    toggleState(id: number, published: boolean): BackendResponse<{project: BuilderProject}> {
        return this.http.put(`${Projects.BASE_URI}/${id}`, {published});
    }

    delete(ids: number[]): BackendResponse<void> {
        return this.http.delete(`${Projects.BASE_URI}/${ids}`);
    }

    generateThumbnail(projectId: number, dataUrl: string): BackendResponse<void> {
        return this.http.post(`${Projects.BASE_URI}/${projectId}/generate-thumbnail`, {dataUrl});
    }
    generateFavIcon(projectId: number, dataUrl: string): BackendResponse<{path: string, status: string}> {
        return this.http.post(`${Projects.BASE_URI}/${projectId}/generate-favicon`, {dataUrl});
    }
    generateOgImage(projectId: number, dataUrl: string): BackendResponse<{path: string, status: string}> {
        return this.http.post(`${Projects.BASE_URI}/${projectId}/generate-ogimage`, {dataUrl});
    }
    uploadToRootDir(projectId: number, formData: FormData,filename: string): BackendResponse<{path: string, status: string}> {
        return this.http.post(`${Projects.BASE_URI}/${projectId}/upload-to-root-dir/${filename}`, formData);
    }
    generatePdfFile(projectId: number, formData: FormData): BackendResponse<{path: string, status: string}> {
        return this.http.post(`${Projects.BASE_URI}/${projectId}/generate-pdfFile`, formData);
    }
    
    getCsrfToken(): Observable<any> {
        
        return this.httpClient.get(`api/v1/get-csrf-token`);
    }

    exportToFtp(projectId: number, params: FtpDetails): BackendResponse<{project: BuilderProject}> {
        return this.http.post(`${Projects.BASE_URI}/${projectId}/export/ftp`, params);
    }
}
